export const SET_JOURNALS = 'SET_JOURNALS';
export const SET_JOURNAL = 'SET_JOURNAL';
export const ADD_JOURNAL = 'ADD_JOURNAL';
export const UPDATE_JOURNAL = 'UPDATE_JOURNAL';
export const REMOVE_JOURNAL = 'REMOVE_JOURNAL';
export const CLEAR_JOURNAL = 'CLEAR_JOURNAL';
export const CLEAR_JOURNALS = 'CLEAR_JOURNALS';
